import { Button, Dropdown, Menu, MenuProps, Segmented, Tooltip } from 'antd';
import LoadingIndicator from 'components/LoadingIndicator';
import { Viewport } from 'components/ViewportProvider';
// import MainCategoryNavMobile from 'containers/MainCategoryMobile';
import { SearchOutlined } from '@ant-design/icons';
import VisuallyHidden from 'components/VisuallyHidden';
import usePopstateLanguage from 'hooks/usePopStateLanguage';
import debounce from 'lodash/debounce';
import qs from 'qs';
import React, { FC, Suspense, lazy, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import translations from 'translations';
import { Buyer, Category, GetTrendingSearchForGuestUserResponse, Language, Store } from 'types/schema';
import { PHONE_NUMBER } from 'utils/constants';
import { createSearchQueryfromSlug, getPathSegmentFromSlug } from 'utils/getPathSegmentFromSlug';
import messages from 'utils/messages';
import { viewPermissions } from 'utils/permissionMap';
import { parse, stringify } from 'utils/queryString';
import renderCategoryName from 'utils/renderCategoryName';
import { EventName, sendGA4Event } from 'utils/triggerGA4Event';
import { pathnameChecker } from 'utils/url';
import CategoryNav from '../../containers/CategoryNav';
import farmToTableMessages from '../../containers/LandingPage/FarmToTablePage/messages';
import SVGIcon from '../SVGIcon/SVGIcon';
import { ArrowDownSwitchStoreIcon } from './ArrowDownSwitchStore';
import BlogDropDown from './BlogDropDown';
import Cart from './CartV3.svg';
import { CategoryIcon } from './CategoryIcon';
import CheckIcon from './CheckIcon.svg';
import DownloadAndroidApp from './DownloadAndroidApp.svg';
import DownloadAndroidAppVi from './DownloadAndroidAppVi.svg';
import DownloadIOSApp from './DownloadIOSApp.svg';
import DownloadIOSAppVi from './DownloadIOSAppVi.svg';
import FavoriteIcon from './FavoriteV3.svg';
import HamburgerMenu from './HamburgerMenu.svg';
import Kamereo from './Kamereo.svg';
import KamereoInfo from './KamereoInfo';
import KamereoV2 from './KamereoV2.svg';
import { LocationIcon } from './Location';
import topNavMessage from './messages';
import Mobile from './Mobile.svg';
import Phone from './Phone.svg';
import QuickOrderEntry from './QuickOrderEntry';
import { SEARCH_HISTORY_KEY } from './SearchWithDropDown';
import './topNav.css';
import TopNavCategory from './TopNavCategory';
import {
  AntdInput,
  CustomSearchInput,
  EnvIndicator,
  FlexContainer,
  Header,
  HeaderText,
  HeaderWrapper,
  InputContainer,
  KamereoLogo,
  LeftNav,
  LinkText,
  MenuItem,
  MenuItemLink,
  MenuLabel,
  MiddleNav,
  /* ProfileInfoContainer, */
  RightNav,
  ScrollProgressBar,
  SignInSignUpWrapper,
  SignUpButton,
  StoreName,
  SwitchRegionContainer,
  SwitchStoreContainer,
  SwitchStoreMobileContainer,
  SwitchStoreText,
  TopNavBadge,
  TopNavButtonHiddenOnMobile,
  TopNavContent,
  TopNavLinkItem,
  /* TopNavMenuItem, */
  TopNavTopContent,
  TopNavTopContentLeft,
  TopNavTopContentRight,
  TopNavTopContentWrapper,
  TopNavWrapper,
} from './TopNavComponents';
import WebQRCode from './WebQRcode.png';

const checkingKeywords = new Set<string>();

const SearchWithDropDown = lazy(() => import('components/MainNav/SearchWithDropDown'));

interface ITopNavProps extends RouteComponentProps {
  opened: boolean;
  user: any;
  store: Store;
  buyer: Buyer & {
    loading: boolean;
  };
  cart: { cartSet: any[] };
  permissions: string[];
  onToggle: () => void | undefined;
  onSignout: () => void | undefined;
  onSetLang: (data: any) => void | undefined;
  categories: Category[];
  hasUnreadNotification: boolean;
  setSearchProductResults: (payload: any) => void;
  clearSearchProductResults: () => void;
  checkBadword: (params: { keyword: string; cb: () => void }) => void;
  handleSaveSearchKeyword: (keyword: string) => void;
  trendingSearchData: GetTrendingSearchForGuestUserResponse;
}

const LangSwitcher = styled(Segmented)`
  background-color: transparent;
  color: #ffffff;
  padding: 0 10px;
  &.ant-segmented {
    .ant-segmented-group {
      gap: 8px;
    }
    .ant-segmented-item-selected {
      color: #fff;
      font-family: 'Maven Pro';
      font-size: 13px;
      font-weight: 500;
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.15);
    }
    .ant-segmented-item-label {
      min-height: 24px;
      line-height: 100%;
      padding: 4px;
    }
    .ant-segmented-thumb {
      background: rgba(255, 255, 255, 0.05);
    }
    .ant-segmented-item:hover:not(.ant-segmented-item-selected):not(.ant-segmented-item-disabled) {
      background: rgba(255, 255, 255, 0.05);
      color: #fff;
    }

    .ant-segmented-item:active:not(.ant-segmented-item-selected):not(.ant-segmented-item-disabled) {
      background: rgba(255, 255, 255, 0.05);
      color: #fff;
    }
  }
`;

export const CategoryIconWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 10px 16px;
  font-size: 15px;
  color: #424242;
  border: 1px solid rgba(189, 189, 189, 0.6);
  height: fit-content;
  border-radius: 8px;
  cursor: pointer;
  &:hover {
    background: #fafafa;
    font-weight: 500;
    border-color: rgba(189, 189, 189, 0.6);
  }

  ${({ isActive }) =>
    isActive &&
    `
    color: #4caf50;
    border-color: #4CAF50 !important;
    background: #fafafa;
    div div svg {
      filter: invert(53%) sepia(9%) saturate(3454%) hue-rotate(73deg) brightness(99%) contrast(68%);
    }
  `}
`;
export const LanguageItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
`;

const RegionItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;
const RegionLabel = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  color: #242527;
`;
const HeaderIconWrapper = styled.div`
  position: relative;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #424242;
  &:hover {
    background: #fafafa;
  }
  &.active {
    background: #fafafa;
    color: #4caf50;
  }
`;

const ChangeRegionContainer = styled.div`
  height: 100%;
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-selected {
    background: transparent;
    &:hover {
      background: rgba(66, 66, 66, 0.05);
    }
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item-divider {
    margin: 0px 12px;
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:not(:last-child) {
    padding: 12px 12px 8px;
  }
  .ant-dropdown .ant-dropdown-menu .ant-dropdown-menu-item:last-child {
    padding: 8px 12px 12px;
  }
  ${({ isMobile }) =>
    !isMobile &&
    `
    padding-left: 10px;
  `}
`;
const RegionContainer = styled.span`
  font-size: 13px;
  font-weight: 400;
  line-height: 100%;
  color: #ffffff;
`;
const RegionName = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 100%;
  color: #ffffff;
`;
const SearchWithDropDownComponent = styled(SearchWithDropDown)`
  position: absolute;
  top: 50px;
  left: 0px;
`;
const debounceInput = debounce((cb) => {
  cb();
}, 300);

/* ******************************************* */
const SideNavMobileComponent = lazy(() => import('./SideNavMobile'));
const TopNavMenuItem = lazy(() => import('./TopNavComponents').then((module) => ({ default: module.TopNavMenuItem })));
const ProfileInfoContainer = lazy(() =>
  import('./TopNavComponents').then((module) => ({ default: module.ProfileInfoContainer })),
);
const MainCategoryNavMobile = lazy(() => import('containers/MainCategoryMobile'));
/* ******************************************* */

const profileMenu = (onSignout: () => void | undefined) => (
  <Menu>
    <Menu.Item key="0">
      <MenuItemLink to="/account-info">
        <MenuLabel>
          <FormattedMessage {...messages.accountSetting} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="1">
      <MenuItemLink to="/refer-friends">
        <MenuLabel>
          <FormattedMessage {...topNavMessage.referralMenuItem} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="2">
      <MenuItemLink to="/orders">
        <MenuLabel>
          <FormattedMessage {...messages.orderHistory} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="3">
      <MenuItemLink to="/overview">
        <MenuLabel>
          <FormattedMessage {...messages.overviewReport} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="4">
      <MenuItemLink to="/company-info">
        <MenuLabel>
          <FormattedMessage {...messages.businessSettings} />
        </MenuLabel>
      </MenuItemLink>
    </Menu.Item>
    <Menu.Item key="5">
      <MenuItem color="#FE5043" onClick={onSignout}>
        <MenuLabel>
          <FormattedMessage {...messages.signout} />
        </MenuLabel>
      </MenuItem>
    </Menu.Item>
  </Menu>
);

const TopNav: FC<ITopNavProps> = (props) => {
  const {
    onSignout,
    onSetLang,
    user,
    cart,
    store,
    buyer,
    permissions: userPermissions,
    history,
    location,
    setSearchProductResults,
    clearSearchProductResults,
    checkBadword,
    handleSaveSearchKeyword,
  } = props;

  const [lang, setLang] = usePopstateLanguage();
  const region = window.localStorage.getItem('region') || 'HCM';
  const loggedIn = !!localStorage.getItem('token');
  const segment = getPathSegmentFromSlug(location);
  const searchQuery = createSearchQueryfromSlug(location, segment);
  const search = parse(searchQuery);
  const fromQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
  const [isOpenSideNav, setIsOpenSideNav] = useState(false);
  const [isOpenCategory, setIsOpenCategory] = useState(false);
  const [showTopHeader, setShowTopHeader] = useState(true);
  const lastScrollTop = useRef(0);
  const [showHeader, setShowHeader] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [currentSection, setCurrentSection] = useState('OUR_STORY');

  const canAccessView = (path: string): boolean => {
    const permissions: string[] = viewPermissions[path];
    if (permissions) {
      let permissionCounter = 0;
      for (const permission of permissions) {
        if (userPermissions.indexOf(permission) > -1) {
          permissionCounter += 1;
        }
      }

      if (permissionCounter !== permissions.length) {
        return false;
      }
    }
    return true;
  };

  const items = [
    {
      label: 'VN',
      value: Language.Vi,
    },
    {
      label: 'EN',
      value: Language.En,
    },
  ];

  const regionItems: MenuProps['items'] = [
    {
      key: 'HCM',
      label: (
        <RegionItem
          onClick={() => {
            window.localStorage.setItem('region', 'HCM');
            window.location.reload();
          }}
        >
          <RegionLabel>
            <FormattedMessage {...messages.southern} />
          </RegionLabel>
          {region === 'HCM' && <img src={CheckIcon} alt="Check Icon" width="24" height="24" loading="lazy" />}
        </RegionItem>
      ),
    },
    {
      type: 'divider',
    },
    {
      key: 'HN',
      label: (
        <RegionItem
          onClick={() => {
            window.localStorage.setItem('region', 'HN');
            window.location.reload();
          }}
        >
          <RegionLabel>
            <FormattedMessage {...messages.northern} />
          </RegionLabel>
          {region === 'HN' && <img src={CheckIcon} alt="Check Icon" width="24" height="24" loading="lazy" />}
        </RegionItem>
      ),
    },
  ];
  const sectionIds = useMemo(() => {
    let data = [
      {
        id: 'OUR_STORY',
        text: translations(farmToTableMessages.ourStory),
      },
      {
        id: 'PROCESS',
        text: translations(farmToTableMessages.process),
      },
      {
        id: 'BENEFITS',
        text: translations(farmToTableMessages.benefits),
      },
      {
        id: 'PRODUCT_CATEGORY',
        text: translations(farmToTableMessages.productCategory),
      },
      {
        id: 'PARTNERS',
        text: translations(farmToTableMessages.partners),
      },
      {
        id: 'CONTACT_US',
        text: translations(farmToTableMessages.contactUs),
      },
    ];
    if (loggedIn) {
      data = [
        {
          id: 'OUR_STORY',
          text: translations(farmToTableMessages.ourStory),
        },
        {
          id: 'PRODUCT_CATEGORY',
          text: translations(farmToTableMessages.productCategory),
        },
        {
          id: 'PROCESS',
          text: translations(farmToTableMessages.process),
        },
        {
          id: 'BENEFITS',
          text: translations(farmToTableMessages.benefits),
        },
        {
          id: 'PARTNERS',
          text: translations(farmToTableMessages.partners),
        },
      ];
    }
    return data;
  }, [loggedIn]);

  const [keyword, setKeyWord] = useState<string>('');
  const [tempKeyword, setTempKeyword] = useState('');
  const [isOpenSearchResultDropdown, setIsOpenSearchResultDropdown] = useState(false);
  const [isSideBarMounted, setIsSideBarMounted] = useState<boolean>(false);
  const [isCheckingBadword, setIsCheckingBadword] = useState<boolean>(false);
  const searchInputContainer = useRef<any>(null);
  const searchInput = useRef<any>(null);
  const checkShowCategorySelector = useMemo(() => {
    const isFavoritePage = pathnameChecker.isOtherPage(location.pathname, '/favorite');
    const isMarketRoutes = pathnameChecker.isMarketRoutes(location.pathname);
    return {
      isShow: isFavoritePage || isMarketRoutes,
      isNotShow: !isFavoritePage && !isMarketRoutes,
    };
  }, [location.pathname]);
  const isFarmToTablePage = location.pathname === '/tu-nong-trai-den-doanh-nghiep';
  const onChangeSearch = (event) => {
    if (!keyword && event.target.value.length === 1) {
      sendGA4Event(EventName.SEARCH_TYPING);
    }

    setKeyWord(event.target.value);
    debounceInput(() => {
      if (event.target.value) {
        const query = parse(location.search);
        setSearchProductResults({
          query: {
            filter: {
              query: event.target.value,
              categoryIds: query?.filter?.categoryIds?.[0] ? [query?.filter?.categoryIds?.[0]] : [],
              // withexclusive: true,
            },
          },
          clearPreviousData: true,
        });
      } else {
        clearSearchProductResults();
      }
      setTempKeyword(event.target.value);
    });
  };

  const handleOnSearch = useCallback(() => {
    if (!keyword) return;
    const searchParams = stringify({
      // ...filterableKeysParams,
      q: keyword || undefined,
      favorite: undefined,
      // withexclusive: true,
    });
    history.push({
      pathname: `/market`,
      search: searchParams,
    });
    setIsOpenSearchResultDropdown(false);
    searchInput?.current?.blur();
    const cleanKeyword = keyword.trim().toLowerCase();
    const detectRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b|(?:\+84|0)(?:\d{9,10})|\b\d{4,8}\b/i; // check phone number, otp, email
    if (!cleanKeyword || detectRegex.test(cleanKeyword)) return;
    if (!loggedIn) {
      const searchHistory = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY)?.toString() || '[]');
      if (!searchHistory.includes(cleanKeyword) && !isCheckingBadword && !checkingKeywords.has(cleanKeyword)) {
        setIsCheckingBadword(true);
        checkingKeywords.add(cleanKeyword);
        checkBadword({
          keyword: cleanKeyword,
          cb: () => {
            const updatedHistory = [...searchHistory];
            updatedHistory.unshift(cleanKeyword);
            const newValue = updatedHistory.slice(0, 5);
            localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(newValue));
            setIsCheckingBadword(false);
            checkingKeywords.delete(cleanKeyword);
          },
        });
      }
    } else {
      handleSaveSearchKeyword(cleanKeyword);
    }
    sendGA4Event(EventName.SEARCH_SUBMIT, {
      keyword: keyword,
      keyword_length: keyword?.trim().length,
      filters_applied: false,
      source: 'manual',
    });
  }, [keyword, history]);

  const handleToggleSideNav = () => {
    const bodyElement = document.querySelector('body');
    if (!isOpenSideNav && bodyElement) {
      bodyElement.classList.add('hideScroll');
      if (!isSideBarMounted) {
        setIsSideBarMounted(true);
      }
    } else if (bodyElement) {
      bodyElement.classList.remove('hideScroll');
    }
    setIsOpenSideNav(!isOpenSideNav);
  };
  const handleToggleCategory = () => {
    setIsOpenCategory(!isOpenCategory);
  };

  const closeSearchResultsDropdown = (e) => {
    if (!searchInputContainer.current?.contains(e.target)) {
      setIsOpenSearchResultDropdown(false);
    }
  };

  const scrollToSection = (id, offset = 100) => {
    const element = document.getElementById(id);
    setCurrentSection(id);
    if (element) {
      let top = element.getBoundingClientRect().top + window.scrollY - offset;
      if (id === 'OUR_STORY') {
        top = 0;
      }
      window.scrollTo({ behavior: 'smooth', top: top });
    }
  };

  useEffect(() => {
    /* Dispatch signout action when user click signout button from Kamereo blog */
    if (Object.keys(fromQuery).length && fromQuery.from === 'blog') {
      const action = fromQuery.action;
      switch (action) {
        case 'signout': {
          onSignout();
          break;
        }
        default:
          break;
      }
    }

    if (location.pathname === '/favorite') {
      setKeyWord('');
      setTempKeyword('');
      clearSearchProductResults();
      return;
    }
    setKeyWord(search.filter?.query || '');
    setTempKeyword(search.filter?.query || '');
    if (!search.filter?.query) {
      clearSearchProductResults();
    }
  }, [location.search]);

  useEffect(() => {
    document.addEventListener('mousedown', closeSearchResultsDropdown);
    return () => {
      document.removeEventListener('mousedown', closeSearchResultsDropdown);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop.current && currentScroll > 100) {
        setShowTopHeader(false);
      } else if (currentScroll < lastScrollTop.current) {
        setShowTopHeader(true);
      }
      lastScrollTop.current = currentScroll <= 0 ? 0 : currentScroll;
    };
    if (isFarmToTablePage) {
      window.addEventListener('scroll', handleScroll);
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.scrollHeight - window.innerHeight;
      const scrolled = (scrollTop / docHeight) * 100;
      setScrollProgress(scrolled);
      if (scrollTop > 100) {
        if (!showHeader) setShowHeader(true);
      } else {
        setShowHeader(false);
      }
    };
    if (isFarmToTablePage) {
      window.addEventListener('scroll', handleScroll);
      return () => window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const id = entry.target.getAttribute('id');
            if (id) setCurrentSection(id);
          }
        });
      },
      {
        threshold: 0.3,
      },
    );
    if (isFarmToTablePage) {
      setTimeout(() => {
        sectionIds.forEach(({ id }) => {
          const el = document.getElementById(id);
          if (el) observer.observe(el);
        });
      }, 500);

      return () => {
        sectionIds.forEach(({ id }) => {
          const el = document.getElementById(id);
          if (el) observer.unobserve(el);
        });
      };
    }
  }, []);
  return (
    <>
      <TopNavWrapper visible={!isFarmToTablePage || showTopHeader}>
        <TopNavTopContentWrapper>
          <TopNavTopContent>
            <TopNavTopContentLeft>
              <Viewport.Consumer>
                {({ width }) => {
                  return (
                    width >= 768 && (
                      <>
                        <Tooltip
                          placement="bottomLeft"
                          title={() => {
                            return (
                              <div className="header-download__container">
                                <div className="header-download__content">
                                  <div className="header-download__left">
                                    <img src={WebQRCode} width="148" height="148" loading="lazy" />
                                  </div>
                                  <div className="header-download__right">
                                    <span>{translations(topNavMessage.scanQRorDownloadApp)}</span>
                                    <div className="mt-16">
                                      <a
                                        href="https://play.google.com/store/apps/details?id=vn.kamereo.buyer&amp;hl=en_US&amp;gl=US"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        <img
                                          src={lang === 'vi' ? DownloadAndroidAppVi : DownloadAndroidApp}
                                          width="112px"
                                          height="33px"
                                          alt="playstoreimage"
                                          loading="lazy"
                                        />
                                        <VisuallyHidden asComponent="span">
                                          {`${translations(topNavMessage.downloadKamereoApp)} Android`}
                                        </VisuallyHidden>
                                      </a>
                                    </div>
                                    <div>
                                      <a
                                        href="https://apps.apple.com/sa/app/kamereo/id1469505654"
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        <img
                                          src={lang === 'vi' ? DownloadIOSAppVi : DownloadIOSApp}
                                          width="112px"
                                          height="33px"
                                          alt="applestoreimage"
                                          loading="lazy"
                                        />
                                        <VisuallyHidden asComponent="span">
                                          {`${translations(topNavMessage.downloadKamereoApp)} iOS`}
                                        </VisuallyHidden>
                                      </a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            );
                          }}
                          overlayClassName="top-nav-tooltip-container"
                        >
                          <FlexContainer>
                            <SVGIcon
                              renderAsImg={false}
                              src={Mobile}
                              beforeInjection={(svg) => {
                                svg.setAttribute('style', 'width: 10px');
                              }}
                            />
                            <p>{translations(topNavMessage.downloadKamereoApp)}</p>
                          </FlexContainer>
                        </Tooltip>
                      </>
                    )
                  );
                }}
              </Viewport.Consumer>
              <FlexContainer>
                <SVGIcon
                  renderAsImg={false}
                  src={Phone}
                  beforeInjection={(svg) => {
                    svg.setAttribute('style', 'width: 14px');
                  }}
                />
                <a href={PHONE_NUMBER}>0812 46 37 27</a>
              </FlexContainer>
            </TopNavTopContentLeft>
            <TopNavTopContentRight>
              <Viewport.Consumer>
                {({ width }) => {
                  return (
                    width >= 576 && (
                      <>
                        <div className="top-nav-item">
                          <KamereoInfo />
                        </div>
                        <div className="top-nav-item">
                          <BlogDropDown />
                        </div>
                        {loggedIn && (
                          <div className="top-nav-item">
                            <TopNavLinkItem to="/notifications" className="no-padding">
                              <FormattedMessage {...messages.notification} />
                            </TopNavLinkItem>
                          </div>
                        )}
                      </>
                    )
                  );
                }}
              </Viewport.Consumer>
              <LangSwitcher
                animation={false}
                options={items}
                // defaultValue={lang}
                value={lang}
                onChange={(value) => {
                  setLang(value);
                  onSetLang(value);
                }}
              />
              {!loggedIn && (
                <ChangeRegionContainer>
                  <Dropdown
                    menu={{ items: regionItems, selectable: true, defaultSelectedKeys: [region] }}
                    placement="bottom"
                    getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
                  >
                    <SwitchRegionContainer>
                      <LocationIcon color="#ffffff" />
                      <RegionContainer>
                        {region === 'HCM' ? (
                          <RegionName>
                            <FormattedMessage {...messages.southern} />
                          </RegionName>
                        ) : (
                          <RegionName>
                            <FormattedMessage {...messages.northern} />
                          </RegionName>
                        )}
                      </RegionContainer>
                      <ArrowDownSwitchStoreIcon color="#ffffff" />
                    </SwitchRegionContainer>
                  </Dropdown>
                </ChangeRegionContainer>
              )}
              {loggedIn && (
                <>
                  <Link to="/change-store">
                    <SwitchStoreContainer>
                      <LocationIcon />
                      <SwitchStoreText>
                        <StoreName>{store.name}</StoreName>&nbsp;|&nbsp;
                        {buyer?.region === 'HN' ? (
                          <FormattedMessage {...messages.northern} />
                        ) : (
                          <FormattedMessage {...messages.southern} />
                        )}
                      </SwitchStoreText>
                      <ArrowDownSwitchStoreIcon />
                    </SwitchStoreContainer>
                  </Link>
                </>
              )}
            </TopNavTopContentRight>
          </TopNavTopContent>
        </TopNavTopContentWrapper>
        <TopNavContent>
          <Viewport.Consumer>
            {({ width }) => (
              <LeftNav>
                <TopNavLinkItem to="/" isLogoNav={true} aria-label="Kamereo logo">
                  <KamereoLogo
                    src={width <= 767 ? KamereoV2 : Kamereo}
                    alt="KAMEREO - Đối tác cung cấp thực phẩm uy tín"
                  />
                  {location.pathname === '/' && (
                    <VisuallyHidden asComponent="h1">KAMEREO - Đối tác cung cấp thực phẩm uy tín</VisuallyHidden>
                  )}
                </TopNavLinkItem>
                {width > 1024 && (
                  <CategoryIconWrapper onClick={handleToggleCategory} isActive={isOpenCategory}>
                    <CategoryIcon isActive={isOpenCategory} />
                    <FormattedMessage {...messages.category} />
                  </CategoryIconWrapper>
                )}
                <>{process.env.APP_ENV === 'production' ? '' : <EnvIndicator>QA</EnvIndicator>}</>
              </LeftNav>
            )}
          </Viewport.Consumer>
          <Viewport.Consumer>
            {({ width }) => {
              return loggedIn ? (
                <>
                  <MiddleNav>
                    {(width > 1024 || (width <= 1024 && checkShowCategorySelector.isNotShow)) && (
                      <InputContainer ref={searchInputContainer} homePage={location.pathname !== '/market'}>
                        {(location.pathname !== '/market' || width > 1024) && (
                          <>
                            <CustomSearchInput
                              ref={searchInput}
                              onChange={onChangeSearch}
                              onPressEnter={handleOnSearch}
                              value={keyword}
                              placeholder={`${translations(messages.searchProducts)}`}
                              size="default"
                              suffix={
                                <SearchOutlined
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOnSearch();
                                  }}
                                  style={{ fontSize: '21px', color: 'rgb(67, 160, 71)', cursor: 'pointer' }}
                                />
                              }
                            >
                              <AntdInput
                                onFocus={() => {
                                  setIsOpenSearchResultDropdown(true);
                                  if (!isOpenSearchResultDropdown) {
                                    sendGA4Event(EventName.SEARCH_FOCUS, {
                                      page_source:
                                        window.scrollY > 0
                                          ? 'sticky_bar'
                                          : location.pathname === '/'
                                            ? 'home'
                                            : 'header',
                                    });
                                  }
                                }}
                              />
                            </CustomSearchInput>

                            {isOpenSearchResultDropdown && (
                              <Suspense fallback={<LoadingIndicator />}>
                                <SearchWithDropDownComponent
                                  keyword={tempKeyword}
                                  onCloseDropdown={() => setIsOpenSearchResultDropdown(false)}
                                />
                              </Suspense>
                            )}
                          </>
                        )}
                      </InputContainer>
                    )}
                    {width <= 767 && loggedIn ? (
                      <QuickOrderEntry variant="mobile" style={{ marginLeft: 12 }} />
                    ) : null}
                    {width <= 1024 && location.pathname.includes('/products/') && canAccessView('/checkout/step/1') && (
                      <TopNavLinkItem to="/checkout/step/1" className="no-padding">
                        <HeaderIconWrapper
                          className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                        >
                          <TopNavBadge>
                            {cart.cartSet.map((cartSet) => cartSet.items.length).reduce((a, b) => a + b, 0)}
                          </TopNavBadge>
                          <SVGIcon
                            src={Cart}
                            className="relative-position"
                            imgAttr={{ width: '24px', height: '24px' }}
                          />
                        </HeaderIconWrapper>
                      </TopNavLinkItem>
                    )}
                    {checkShowCategorySelector.isShow && width < 1025 && location?.pathname !== '/market' && (
                      <Suspense fallback={<LoadingIndicator />}>
                        <MainCategoryNavMobile />
                      </Suspense>
                    )}
                  </MiddleNav>
                  {/* right nav */}
                  <RightNav className="login" transition={width > 1024 && isFarmToTablePage && !showTopHeader}>
                    {width > 1024 && (
                      <>
                        <LinkText to="/favorite">
                          <HeaderIconWrapper className={['/favorite'].includes(location.pathname) ? 'active' : ''}>
                            <SVGIcon src={FavoriteIcon} imgAttr={{ width: '27px', height: '24px' }} />
                          </HeaderIconWrapper>
                        </LinkText>
                      </>
                    )}
                    {width > 1024 && (
                      <>
                        <LinkText to="/quick-order">
                          <QuickOrderEntry />
                        </LinkText>
                      </>
                    )}
                    {width <= 767 && (
                      <SwitchStoreMobileContainer>
                        <Link to="/change-store">
                          <SVGIcon src={Location} renderAsImg={false} />
                          <SwitchStoreText>
                            <StoreName>{store.name}</StoreName>&nbsp;|&nbsp;
                            {buyer?.region === 'HN' ? (
                              <FormattedMessage {...messages.northern} />
                            ) : (
                              <FormattedMessage {...messages.southern} />
                            )}
                          </SwitchStoreText>
                        </Link>
                      </SwitchStoreMobileContainer>
                    )}
                    {width <= 767 && <SVGIcon src={HamburgerMenu} onClick={handleToggleSideNav} />}
                    {width > 1024 && (
                      <>
                        {canAccessView('/checkout/step/1') && (
                          <TopNavLinkItem to="/checkout/step/1" className="no-padding">
                            <HeaderIconWrapper
                              className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                            >
                              <TopNavBadge>
                                {cart.cartSet.map((cartSet) => cartSet.items.length).reduce((a, b) => a + b, 0)}
                              </TopNavBadge>
                              <SVGIcon
                                src={Cart}
                                className="relative-position"
                                imgAttr={{ width: '24px', height: '24px' }}
                              />
                            </HeaderIconWrapper>
                          </TopNavLinkItem>
                        )}
                      </>
                    )}
                    {width > 1024 && (
                      <Suspense fallback={<LoadingIndicator />}>
                        <TopNavMenuItem
                          overlay={() => profileMenu(onSignout)}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <ProfileInfoContainer user={user} />
                        </TopNavMenuItem>
                      </Suspense>
                    )}
                  </RightNav>
                </>
              ) : (
                <>
                  <MiddleNav>
                    {(width > 576 || (width < 576 && checkShowCategorySelector.isNotShow)) && (
                      <InputContainer ref={searchInputContainer} homePage={location.pathname !== '/market'}>
                        {width <= 767 && (
                          <ChangeRegionContainer isMobile>
                            <Dropdown
                              trigger={['click']}
                              menu={{ items: regionItems, selectable: true, defaultSelectedKeys: [region] }}
                              placement="bottom"
                              getPopupContainer={(triggerNode) => triggerNode.parentElement as HTMLElement}
                            >
                              <SwitchRegionContainer>
                                <LocationIcon color="#ffffff" />
                                <RegionContainer>
                                  {region === 'HCM' ? (
                                    <RegionName>
                                      <FormattedMessage {...messages.southern} />
                                    </RegionName>
                                  ) : (
                                    <RegionName>
                                      <FormattedMessage {...messages.northern} />
                                    </RegionName>
                                  )}
                                </RegionContainer>
                                <ArrowDownSwitchStoreIcon color="#ffffff" />
                              </SwitchRegionContainer>
                            </Dropdown>
                          </ChangeRegionContainer>
                        )}
                        {(location.pathname !== '/market' || width > 1024) && (
                          <>
                            <CustomSearchInput
                              ref={searchInput}
                              onChange={onChangeSearch}
                              onPressEnter={handleOnSearch}
                              value={keyword}
                              placeholder={`${translations(messages.search)} ${translations(
                                messages.in,
                              )} ${renderCategoryName(undefined, search, 'KAMEREO')}`}
                              size="default"
                              suffix={
                                <SearchOutlined
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleOnSearch();
                                  }}
                                  style={{ fontSize: '21px', color: 'rgb(67, 160, 71)', cursor: 'pointer' }}
                                />
                              }
                            >
                              <AntdInput
                                onFocus={() => {
                                  setIsOpenSearchResultDropdown(true);
                                  if (!isOpenSearchResultDropdown) {
                                    sendGA4Event(EventName.SEARCH_FOCUS, {
                                      page_source:
                                        window.scrollY > 0
                                          ? 'sticky_bar'
                                          : location.pathname === '/'
                                            ? 'home'
                                            : 'header',
                                    });
                                  }
                                }}
                              />
                            </CustomSearchInput>
                            {isOpenSearchResultDropdown && (
                              <Suspense fallback={<LoadingIndicator />}>
                                <SearchWithDropDownComponent
                                  keyword={tempKeyword}
                                  onCloseDropdown={() => setIsOpenSearchResultDropdown(false)}
                                />
                              </Suspense>
                            )}
                          </>
                        )}
                      </InputContainer>
                    )}
                    {checkShowCategorySelector.isShow && width < 1025 && location?.pathname !== '/market' && (
                      <Suspense fallback={<LoadingIndicator />}>
                        <MainCategoryNavMobile />
                      </Suspense>
                    )}
                  </MiddleNav>
                  {/* right nav */}
                  <RightNav transition={width > 1024 && isFarmToTablePage && !showTopHeader}>
                    {width > 1024 && (
                      <LinkText to="/signin" rel="nofollow">
                        <HeaderIconWrapper className={['/favorite'].includes(location.pathname) ? 'active' : ''}>
                          <SVGIcon src={FavoriteIcon} alt="Favorite" />
                        </HeaderIconWrapper>
                      </LinkText>
                    )}
                    {width <= 767 && (
                      <SwitchStoreMobileContainer>
                        <Link to="/contact-us">
                          <SignUpButton>{translations(topNavMessage.signUp)}</SignUpButton>
                        </Link>
                      </SwitchStoreMobileContainer>
                    )}
                    {width <= 767 && (
                      <QuickOrderEntry variant="mobile" style={{ marginRight: 12 }} />
                    )}
                    {width > 1024 && (
                      <>
                        <LinkText to="/quick-order">
                          <QuickOrderEntry />
                        </LinkText>
                      </>
                    )}
                    {width <= 767 && <SVGIcon src={HamburgerMenu} onClick={handleToggleSideNav} alt="Hambuger menu" />}
                    {width > 1024 && (
                      <>
                        <LinkText to="/signin" rel="nofollow">
                          <HeaderIconWrapper
                            className={location.pathname.split('/').includes('checkout') ? 'active' : ''}
                          >
                            <SVGIcon src={Cart} className="relative-position" alt="Checkout" />
                            <TopNavBadge>0</TopNavBadge>
                          </HeaderIconWrapper>
                        </LinkText>
                      </>
                    )}
                    <SignInSignUpWrapper>
                      <LinkText to="/signin">
                        <TopNavButtonHiddenOnMobile>
                          <FormattedMessage {...messages.signin} />
                        </TopNavButtonHiddenOnMobile>
                      </LinkText>
                      <LinkText to="/contact-us">
                        <TopNavButtonHiddenOnMobile className="contact-us">
                          <Button type="primary" size="small">
                            <FormattedMessage {...messages.signup} />
                          </Button>
                        </TopNavButtonHiddenOnMobile>
                      </LinkText>
                    </SignInSignUpWrapper>
                  </RightNav>
                </>
              );
            }}
          </Viewport.Consumer>
          <Viewport.Consumer>
            {({ width }) =>
              isOpenCategory &&
              width > 991 && <CategoryNav overlay={true} onCloseCategory={() => setIsOpenCategory(false)} />
            }
          </Viewport.Consumer>
        </TopNavContent>
        {isFarmToTablePage && (
          <Viewport.Consumer>
            {({ width }) => {
              const isDesktop = width > 1023;
              return (
                <HeaderWrapper
                  isVisible={isFarmToTablePage && showHeader}
                  showTopHeader={showTopHeader}
                  isDesktop={isDesktop}
                >
                  <Header>
                    {sectionIds.map((section) => (
                      <HeaderText
                        key={section.id}
                        active={currentSection === section.id}
                        onClick={() => scrollToSection(section.id)}
                      >
                        {section.text}
                      </HeaderText>
                    ))}
                  </Header>
                  <ScrollProgressBar width={scrollProgress} />
                </HeaderWrapper>
              );
            }}
          </Viewport.Consumer>
        )}
      </TopNavWrapper>
      <TopNavCategory cart={cart} permissions={userPermissions} />
      <Suspense fallback={<LoadingIndicator />}>
        {isSideBarMounted && (
          <SideNavMobileComponent onCloseSideNav={handleToggleSideNav} opened={isOpenSideNav} onSetLang={onSetLang} />
        )}
      </Suspense>
    </>
  );
};

export default withRouter(TopNav);
